// Listings redesign (DR-81…DR-88) · merchant surface strings. Spread into en.ts; the bn twin is
// lr-merchant-bn.ts. Keys are namespaced `lr.merchant.*`.
export const lrMerchantEn = {
  // ---- tabs ----
  'lr.merchant.tab.nearby': "What's nearby",
  'lr.merchant.tab.trust': 'Trust',
  'lr.merchant.tab.info': 'Listing info',

  // ---- profile: amenities, address, social, policies ----
  'lr.merchant.sec.amenities': 'Amenities',
  'lr.merchant.amenities.hint': 'Pick what the place has — customers filter by these',
  'lr.merchant.amenities.none': 'This category has no amenity list yet.',
  'lr.merchant.amenities.count': '{n} selected',
  'lr.merchant.f.address': 'Street address',
  'lr.merchant.f.address_ph': 'House, road, block — what a visitor types into a map',
  'lr.merchant.sec.social': 'Links',
  'lr.merchant.social.hint': 'Shown on the public page. Full links starting with https://',
  'lr.merchant.f.social.website': 'Website',
  'lr.merchant.f.social.facebook': 'Facebook page',
  'lr.merchant.f.social.whatsapp': 'WhatsApp link (wa.me)',
  'lr.merchant.f.social.instagram': 'Instagram',
  'lr.merchant.f.social.youtube': 'YouTube channel',
  'lr.merchant.err.social': 'Links must start with http:// or https://',
  'lr.merchant.err.address': 'Enter the street address.',
  'lr.merchant.sec.policies': 'Policies',
  'lr.merchant.f.tier': 'Cancellation tier',
  'lr.merchant.f.policy_text': 'House rules & notes',
  'lr.merchant.f.policy_hint': 'Shown under "Booking & payment rules" on your page',
  'lr.merchant.photos.cap': 'Up to {n} photos',

  // ---- what's nearby ----
  'lr.merchant.nearby.title': 'Places near you',
  'lr.merchant.nearby.hint':
    'Up to six landmarks a visitor would recognise — the nearest show first on your page',
  'lr.merchant.nearby.name': 'Place',
  'lr.merchant.nearby.name_ph': 'e.g. Karwan Bazar Metro Station',
  'lr.merchant.nearby.kind': 'Kind',
  'lr.merchant.nearby.distance': 'Distance (m)',
  'lr.merchant.nearby.add': 'Add a place',
  'lr.merchant.nearby.remove': 'Remove place {n}',
  'lr.merchant.nearby.max': 'Six places at most.',
  'lr.merchant.nearby.err.row': 'Place {n} needs a name and a distance in metres.',
  'lr.merchant.nearby.empty':
    'No places yet. The "What\'s nearby" section stays hidden until you add one.',
  'lr.merchant.nearby.walk.title': 'Walkability',
  'lr.merchant.nearby.walk.0': 'Quiet area',
  'lr.merchant.nearby.walk.1': 'Close to a key stop',
  'lr.merchant.nearby.walk.2': 'Walkable area',
  'lr.merchant.nearby.walk.rule':
    'Set from your places: a metro, bus or market within 500 m makes "Walkable area"; within 1 km "Close to a key stop". Customers can filter on it.',
  'lr.merchant.nearby.kind.transit': 'Metro / bus / station',
  'lr.merchant.nearby.kind.market': 'Market / bazar',
  'lr.merchant.nearby.kind.health': 'Hospital / clinic',
  'lr.merchant.nearby.kind.landmark': 'Landmark',
  'lr.merchant.nearby.kind.mosque': 'Mosque',
  'lr.merchant.nearby.kind.attraction': 'Tourist attraction',
  'lr.merchant.nearby.kind.shopping': 'Shopping',
  'lr.merchant.nearby.kind.beach': 'Beach',
  'lr.merchant.nearby.kind.park': 'Park / lake',
  'lr.merchant.nearby.kind.food': 'Restaurant / café',
  'lr.merchant.nearby.kind.other': 'Other',

  // ---- trust: certificates ----
  'lr.merchant.trust.certs.title': 'Licences & certificates',
  'lr.merchant.trust.certs.hint':
    'One document per kind. Only "on file / expired / not on file" is public — never the document itself.',
  'lr.merchant.trust.cert.state.pending': 'Pending review',
  'lr.merchant.trust.cert.state.ok': 'On file',
  'lr.merchant.trust.cert.state.rejected': 'Rejected',
  'lr.merchant.trust.cert.state.expired': 'Expired',
  'lr.merchant.trust.cert.state.none': 'Not on file',
  'lr.merchant.trust.cert.issuer': 'Issued by {issuer}',
  'lr.merchant.trust.cert.expires': 'Expires {date}',
  'lr.merchant.trust.cert.reason': 'Reason: {reason}',
  'lr.merchant.trust.cert.upload': 'Upload',
  'lr.merchant.trust.cert.replace': 'Replace',
  'lr.merchant.trust.cert.remove': 'Remove',
  'lr.merchant.trust.cert.remove_label': 'Remove {kind}',
  'lr.merchant.trust.cert.file_hint': 'JPG, PNG, WebP or PDF, up to 8 MB',
  'lr.merchant.trust.cert.file': 'Document',
  'lr.merchant.trust.cert.pick_file': 'Choose file',
  'lr.merchant.trust.cert.expiry': 'Valid until',
  'lr.merchant.trust.cert.submit': 'Send for review',
  'lr.merchant.trust.cert.cancel': 'Cancel',
  'lr.merchant.trust.cert.uploaded': 'Sent — we will check it within a few days.',
  'lr.merchant.trust.cert.upload_failed': 'The document could not be uploaded — try again.',
  'lr.merchant.trust.cert.too_big': 'The file is larger than 8 MB.',
  'lr.merchant.trust.cert.bad_type': 'Use a JPG, PNG, WebP or PDF file.',
  'lr.merchant.trust.cert.need_all': 'Choose a file and its expiry date.',
  'lr.merchant.trust.cert.bad_expiry': 'The expiry date must be in the future.',
  'lr.merchant.trust.cert.removed': 'Certificate removed.',
  'lr.merchant.trust.cert.remove_failed': 'The certificate could not be removed — try again.',
  'lr.merchant.trust.cert.dialog_title': 'Upload {kind}',

  // ---- trust: inspection ----
  'lr.merchant.trust.insp.title': '{brand} inspection',
  'lr.merchant.trust.insp.none':
    'No published inspection yet. When our team visits and publishes a report it appears here and on your page.',
  'lr.merchant.trust.insp.score': 'Overall score',
  'lr.merchant.trust.insp.inspected': 'Inspected {date}',
  'lr.merchant.trust.insp.valid_until': 'Valid until {date}',
  'lr.merchant.trust.insp.funded.merchant': 'Paid by you',
  'lr.merchant.trust.insp.funded.platform': 'Paid by the platform',
  'lr.merchant.trust.insp.criteria': 'Scores',
  'lr.merchant.trust.insp.note': "Inspector's note",
  'lr.merchant.trust.insp.photos': 'Inspection photos',
  'lr.merchant.trust.insp.reply.placeholder': 'Write your public reply (up to 600 characters)',
  'lr.merchant.trust.insp.reply.send': 'Post reply',
  'lr.merchant.trust.insp.reply.sent': 'Your reply is now on your listing.',
  'lr.merchant.trust.insp.reply.failed': 'The reply could not be posted. Try again.',
  'lr.merchant.trust.insp.reply.title': 'Your public reply',
  'lr.merchant.trust.insp.reply.your': 'Your reply',
  'lr.merchant.trust.insp.reply.unavailable':
    'Replying from here is coming soon — contact support to add a reply.',

  // ---- listing info (type_meta) ----
  'lr.merchant.info.title': 'Listing information',
  'lr.merchant.info.hint':
    'Facts shown on your public page. English is required; Bangla is optional.',
  'lr.merchant.info.en': 'English',
  'lr.merchant.info.bn': 'Bangla',
  'lr.merchant.info.add_row': 'Add',
  'lr.merchant.info.remove_row': 'Remove row {n}',
  'lr.merchant.info.max_rows': 'Up to {n} rows.',
  'lr.merchant.info.none': 'This category has no extra listing information.',
  // hotel
  'lr.merchant.info.hotel.check_in': 'Check-in time',
  'lr.merchant.info.hotel.check_out': 'Check-out time',
  'lr.merchant.info.hotel.floors': 'Floors',
  'lr.merchant.info.hotel.rooms_total': 'Rooms in total',
  // restaurant
  'lr.merchant.info.rest.cuisine': 'Cuisines',
  'lr.merchant.info.rest.cuisine_ph': 'e.g. Bangladeshi, Chinese',
  'lr.merchant.info.rest.seating': 'Seating capacity',
  'lr.merchant.info.rest.note': 'Reservation note',
  // turf
  'lr.merchant.info.turf.facts': 'Pitch facts',
  'lr.merchant.info.turf.fact.format': 'Format',
  'lr.merchant.info.turf.fact.pitch_size': 'Pitch size',
  'lr.merchant.info.turf.fact.surface': 'Surface',
  'lr.merchant.info.turf.fact.setting': 'Setting',
  'lr.merchant.info.turf.fact.lights': 'Lights',
  'lr.merchant.info.turf.fact.power': 'Power',
  'lr.merchant.info.turf.fact.open': 'Open',
  'lr.merchant.info.turf.ramadan': 'Ramadan schedule',
  'lr.merchant.info.turf.bonus': 'Bonus minutes',
  'lr.merchant.info.turf.who': 'Who can play',
  'lr.merchant.info.turf.who.general': 'General booking',
  'lr.merchant.info.turf.who.women': 'Women-only slots',
  'lr.merchant.info.turf.who.family': 'Family slot',
  'lr.merchant.info.turf.who.kids': 'Kids academy',
  'lr.merchant.info.turf.who.title': 'Title',
  'lr.merchant.info.turf.who.detail': 'Details',
  'lr.merchant.info.turf.rules': 'Ground rules',
  'lr.merchant.info.turf.rule.allowed': 'Allowed',
  'lr.merchant.info.turf.rule.not_allowed': 'Not allowed',
  'lr.merchant.info.turf.rule.text': 'Rule',
  'lr.merchant.info.turf.packages': 'Packages',
  'lr.merchant.info.turf.packages_hint':
    'Information with a price label — a package is booked by contacting you, not online.',
  'lr.merchant.info.turf.pkg.tournament': 'Tournament',
  'lr.merchant.info.turf.pkg.corporate': 'Corporate match',
  'lr.merchant.info.turf.pkg.monthly': 'Monthly fixed slot',
  'lr.merchant.info.turf.pkg.play_eat': 'Play + eat',
  'lr.merchant.info.turf.pkg.other': 'Other',
  'lr.merchant.info.turf.pkg.title': 'Title',
  'lr.merchant.info.turf.pkg.detail': 'Details',
  'lr.merchant.info.turf.pkg.price': 'Price label',
  'lr.merchant.info.turf.pay': 'Booking & payment rules',
  'lr.merchant.info.turf.pay_hint': 'Your own words for advance, confirmation, cancelling and rain. Shown on your page above the platform terms.',
  'lr.merchant.info.turf.pay.title': 'Heading',
  'lr.merchant.info.turf.pay.text': 'Rule',
  'lr.merchant.info.turf.pay.advance': 'Advance & balance',
  'lr.merchant.info.turf.pay.confirmation': 'Confirmation',
  'lr.merchant.info.turf.pay.cancel': 'Cancel & reschedule',
  'lr.merchant.info.turf.pay.rain': 'If it rains',
  'lr.merchant.info.turf.pay.other': 'Other',
  'lr.merchant.info.turf.go': 'How to get there',
  'lr.merchant.info.turf.go.address': 'Address',
  'lr.merchant.info.turf.go.landmark': 'Landmark',
  'lr.merchant.info.turf.go.transit': 'Nearest stop',
  'lr.merchant.info.turf.go.rickshaw': 'By rickshaw',
  'lr.merchant.info.turf.go.parking': 'Parking',
  'lr.merchant.info.turf.go.text': 'Directions',
  'lr.merchant.info.turf.faq': 'Common questions',
  'lr.merchant.info.turf.faq.q': 'Question',
  'lr.merchant.info.turf.faq.a': 'Answer',
  'lr.merchant.info.turf.not_available': 'Not available here',
  'lr.merchant.info.turf.not_available_hint':
    'Amenities the turf does not have — shown so nobody expects them',
  'lr.merchant.info.kind': 'Kind',

  // ---- details on file (home checklist) ----
  'lr.merchant.details.line': 'Complete your listing — {name}: {n} of 5 details on file',
  'lr.merchant.details.missing': 'Missing: {list}',
  'lr.merchant.details.missing.photos': 'photos',
  'lr.merchant.details.missing.about': 'description',
  'lr.merchant.details.missing.amenities': 'amenities',
  'lr.merchant.details.missing.price': 'a price',
  'lr.merchant.details.missing.hours': 'opening hours',
  'lr.merchant.details.go': 'Complete',
} as const satisfies Record<string, string>;
